import * as React from 'react';
import PropTypes from 'prop-types';

import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
} from '@material-ui/core';


class DialogButton extends React.Component {
    state = {
        isDialogOpen: false,
    }

    openDialog = () => {
        this.setState({ isDialogOpen: true });
    }

    closeDialog = () => {
        this.setState({ isDialogOpen: false });
    }

    ok = () => {
        this.setState({ isDialogOpen: false }, this.props.dialogOkAction);
    }


    render() {
        const {
            buttonText, dialogTitle, dialogCancelText, buttonProps,
        } = this.props;

        return (
            <>
                <Button
                    onClick={this.openDialog}
                    {...buttonProps}
                >
                    {buttonText}
                </Button>

                <Dialog
                    open={this.state.isDialogOpen}
                    onClose={this.closeDialog}
                >
                    <DialogTitle>{dialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogActions>
                            <Button
                                onClick={this.ok}
                            >
                                {buttonText}
                            </Button>
                            <Button
                                onClick={this.closeDialog}
                                autoFocus
                            >
                                {dialogCancelText}
                            </Button>
                        </DialogActions>
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}

DialogButton.propTypes = {
    dialogOkAction: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
    dialogTitle: PropTypes.string.isRequired,
    dialogCancelText: PropTypes.string.isRequired,
    buttonProps: PropTypes.object,
};

DialogButton.defaultProps = {
    buttonProps: null,
};

export default DialogButton;
